import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ProtectedRoute, PublicRoute } from './components/ProtectedRoute';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import VerifyEmailPage from './components/VerifyEmailPage';
import JoinAsVendorPage from './components/JoinAsVendorPage';
import OrdersPage from './components/OrdersPage';
import BuyerOrderDetailPage from './components/BuyerOrderDetailPage';
import VendorOrderDetailPage from './components/VendorOrderDetailPage';
import CreateReviewPage from './components/CreateReviewPage';
import BuyFoodPage from './components/BuyFoodPage';
import VendorReviewsPage from './components/VendorReviewsPage';
import SellFoodPage from './components/SellFoodPage';
import CheckoutPage from './components/CheckoutPage';
import CartPage from './components/CartPage';
import OAuthCallback from './components/OAuthCallback';
import TopUpPage from './components/TopUpPage';
import ManualTopUpPage from './components/ManualTopUpPage';
import CashOutPage from './components/CashOutPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import ContactPage from './components/ContactPage';
import TermsConditionsPage from './components/TermsConditionsPage';
import FAQPage from './components/FAQPage';
import './App.css';
import Footer from './components/Footer';
import FeedbackCard from './components/FeedbackCard';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <div className="App">
            <main className="App-main">
              <Routes>
                {/* Public Landing Page */}
                <Route path="/" element={<LandingPage />} />

                {/* OAuth Callback */}
                <Route path="/oauth-callback" element={<OAuthCallback />} />

                {/* Join as Vendor Page */}
                <Route path="/vendor" element={<JoinAsVendorPage />} />

                {/* Buy Food Page */}
                <Route path="/buy-food" element={<BuyFoodPage />} />

                {/* Sell Food Page */}
                <Route path="/sell-food" element={<SellFoodPage />} />

                {/* Cart Page */}
                <Route path="/cart" element={<CartPage />} />

                {/* Checkout Page */}
                <Route path="/checkout" element={<CheckoutPage />} />

                {/* Top Up Page */}
                <Route
                  path="/topup"
                  element={
                    <ProtectedRoute>
                      <TopUpPage />
                    </ProtectedRoute>
                  }
                />

                {/* Manual Top Up Page */}
                <Route
                  path="/topup/manual"
                  element={
                    <ProtectedRoute>
                      <ManualTopUpPage />
                    </ProtectedRoute>
                  }
                />

                {/* Cash Out Page */}
                <Route
                  path="/cashout"
                  element={
                    <ProtectedRoute>
                      <CashOutPage />
                    </ProtectedRoute>
                  }
                />

                {/* Public routes - redirect to dashboard if logged in */}
                <Route
                  path="/login"
                  element={
                    <PublicRoute>
                      <LoginPage />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute>
                      <ForgotPasswordPage />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/reset-password"
                  element={
                    <PublicRoute>
                      <ResetPasswordPage />
                    </PublicRoute>
                  }
                />
                
                {/* Email Verification - Public */}
                <Route path="/verify-email" element={<VerifyEmailPage />} />

                {/* Protected routes - redirect to login if not logged in */}
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute>
                      <OrdersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders/buyer/:orderId"
                  element={
                    <ProtectedRoute>
                      <BuyerOrderDetailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders/vendor/:orderItemId"
                  element={
                    <ProtectedRoute>
                      <VendorOrderDetailPage />
                    </ProtectedRoute>
                  }
                />

                {/* Submit a review for an order item */}
                <Route
                  path="/create-review/:orderItemId"
                  element={
                    <ProtectedRoute>
                      <CreateReviewPage />
                    </ProtectedRoute>
                  }
                />

                {/* Vendor reviews (public) */}
                <Route path="/vendors/:vendorId/reviews" element={<VendorReviewsPage />} />

                {/* Privacy Policy (public) */}
                <Route path="/privacy" element={<PrivacyPolicyPage />} />

                {/* Contact (public) */}
                <Route path="/contact" element={<ContactPage />} />

                {/* Terms & Conditions (public) */}
                <Route path="/terms" element={<TermsConditionsPage />} />

                {/* FAQ (public) */}
                <Route path="/FAQ" element={<FAQPage />} />

                {/* Catch all - redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <FeedbackCard />
            <Footer />
          </div>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
